import React from "react";
import { Card, Button, Carousel } from "react-bootstrap";
import { formatToUSDateTime } from "../../utils/dateFormat";
import useCountdown from "../../hooks/useCountdown";
import { FaRegClock } from "react-icons/fa";
import { HiOutlineLocationMarker } from "react-icons/hi";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

export default function EventStrip({ upcomingEvents, loading }) {
  // console.log("Upcoming Events in EventStrip: ", upcomingEvents);

  // const countdown = useCountdown(upcomingEvents?.start_date);
  const countdown = useCountdown(upcomingEvents?.[0]?.start_date);

  return (
    <section className="event-strip my-5">
      <span className="grad-1"></span>
      <span className="grad-2"></span>

      {loading || !upcomingEvents ? (
        <div className="d-flex justify-content-center align-items-center">
          <Skeleton height={350} width={1300} borderRadius={12} />
        </div>
      ) : (
        <Carousel
          indicators={true}
          interval={5000}
          pause="hover"
          className="event-carousel"
          controls={false}
        >
          {
            upcomingEvents.map((event) => (
              <Carousel.Item key={event._id}>
                <Card className="p-4 radius-lg event-strip-card border-0 bg-transparent ">
                  <div className="d-flex flex-column flex-lg-row align-items-center gap-4">
                    <div className="event-thumb-image flex-shrink-0">
                      <img
                        src={`${IMAGE_BASEURL}${event?.image_path}`}
                        alt={event?.title || "Event Image"}
                        className="event-thumb-img"
                      />
                    </div>
                    <div className="flex-grow-1 w-100">
                      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-3">
                        <div className="event-info">
                          <small className="d-block mb-2 event-label">
                            Upcoming Event
                          </small>
                          <h2 className="mb-3 event-title">{event?.title}</h2>
                          <p className="mb-3 event-price">
                            Passes start from ${event?.price}
                          </p>
                          <div className="d-flex flex-column align-items-start event-details-text">
                            <span className="d-flex align-items-center">
                              <span className="bg-icons"><FaRegClock /></span>
                              {/* Start {event.startTime} - {event.endTime} */}
                              {formatToUSDateTime(event?.start_date)}
                              {event?.end_date && (
                                <> - {formatToUSDateTime(event?.end_date)}</>
                              )}
                            </span>
                            <span className="d-flex align-items-center">
                              <span className="bg-icons"><HiOutlineLocationMarker /></span>
                              {event?.venue}
                            </span>
                          </div>
                        </div>
                        <div className="countdown-section d-none d-lg-flex flex-column align-items-center">
                          <div className="d-flex gap-2 align-items-center">
                            <div className="count-box">
                              <div className="count-value">{countdown.days}</div>
                              <small className="count-label-white">DAYS</small>
                            </div>
                            <div className="count-box">
                              <div className="count-value">{countdown.hours}</div>
                              <small className="count-label-white">HOURS</small>
                            </div>
                            <div className="count-box">
                              <div className="count-value">{countdown.mins}</div>
                              <small className="count-label-white">MINS</small>
                            </div>
                            <div className="count-box">
                              <div className="count-value">{countdown.secs}</div>
                              <small className="count-label-white">SECO</small>
                            </div>
                          </div>
                          <div className="mt-3 d-flex gap-2 flex-wrap">
                            <Button className="btn btn-orange btn-event-details w-auto px-4 text-capitalize">
                              Reserve Ticket
                            </Button>
                            {/* <Button className="btn-light px-4">
                              EVENT DETAILS
                            </Button> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </Carousel.Item>
            ))
          }
        </Carousel>
      )}
    </section>
  );
}
